var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid full-media-modal p-0"},[_c('div',{staticClass:"row"},[_c('img',{staticClass:"call-event-image center-image",attrs:{"src":_vm.imageUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }